// extracted by mini-css-extract-plugin
export default {"app_loading":"AppLoading_app_loading__LVyWd","tip":"AppLoading_tip__0FTWi","no_fixed":"AppLoading_no_fixed__Fv0M4"};